import * as React from "react";
import {IReadPostResponse} from "../../core/api/post/response/ReadPostResponse";
import ReadMoreReact from 'read-more-react';

interface IProps {
    data: IReadPostResponse[] | null;
}

interface IState {
    item: {
        overview: string,
        vision: string,
        mission: string
    }
}

export class HomeAbout extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            item: {
                overview: '',
                vision: '',
                mission: ''
            }
        }
    }

    public componentDidMount() {
        const data = this.props.data;

        if (data === undefined || data === null || (Array.isArray(data) && data.length <= 0)) {
            this.setState({
                item: {
                    overview: 'Data tidak ditemukan',
                    vision: 'Data tidak ditemukan',
                    mission: 'Data tidak ditemukan'
                }
            });
        } else if (Array.isArray(data) && data.length > 0) {
            const overview = data.filter(item => item.tag === 'gambaran-umum');
            const vision = data.filter(item => item.tag === 'visi');
            const mission = data.filter(item => item.tag === 'misi');

            this.setState({
                item: {
                    overview: overview.length > 0 ? overview[0].description : 'Data tidak ditemukan',
                    vision: vision.length > 0 ? vision[0].description : 'Data tidak ditemukan',
                    mission: mission.length > 0 ? mission[0].description : 'Data tidak ditemukan'
                }
            })
        } else {
            this.setState({
                item: {
                    overview: 'Data tidak ditemukan',
                    vision: 'Data tidak ditemukan',
                    mission: 'Data tidak ditemukan'
                }
            });
        }
    }

    public render() {
        return (
            <section id="services" className="page-section">
                <div className="container relative">
                    <h2 className="section-title font-alt mb-70 mb-sm-40">Tentang Desa</h2>
                    <ul className="nav nav-tabs tpl-alt-tabs font-alt pt-30 pt-sm-0 pb-30 pb-sm-0">
                        <li className="active">
                            <div className="alt-tabs-icon" />
                            <a href="#gambaran-umum" data-toggle="tab">Gambaran Umum </a>
                        </li>
                        <li>
                            <div className="alt-tabs-icon" />
                            <a href="#visi" data-toggle="tab">Visi </a>
                        </li>
                        <li>
                            <div className="alt-tabs-icon" />
                            <a href="#misi" data-toggle="tab">Misi </a>
                        </li>
                    </ul>
                    <div className="tab-content tpl-tabs-cont">
                        <div id="gambaran-umum" className="tab-pane fade in active">
                            <div className="section-text">
                                <div className="row">
                                    <div className="col-md-12 mb-md-40 mb-xs-30">
                                        {this.state.item.overview !== '' && (
                                            <ReadMoreReact text={this.state.item.overview}
                                                min={500}
                                                ideal={500}
                                                max={600}
                                                readMoreText="baca lebih lanjut" />
                                         )}
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="visi" className="tab-pane fade">
                            <div className="section-text">
                                <div className="row">
                                    <div className="col-md-12 mb-md-40 mb-xs-30">
                                        {this.state.item.vision !== '' && (
                                            <ReadMoreReact text={this.state.item.vision}
                                                min={500}
                                                ideal={500}
                                                max={600}
                                                readMoreText="baca lebih lanjut" />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="misi" className="tab-pane fade">
                            <div className="section-text">
                                <div className="row">
                                    <div className="col-md-12 mb-md-40 mb-xs-30">
                                        {this.state.item.mission !== '' && (
                                            <ReadMoreReact text={this.state.item.mission}
                                                min={500}
                                                ideal={500}
                                                max={600}
                                                readMoreText="baca lebih lanjut" />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}


// WEBPACK FOOTER //
// ./src/component/home/HomeAbout.tsx